import { Button, Layout, theme, Form, Select, Input, Spin, notification } from "antd";

import React, { useEffect, useCallback, useState } from "react";
import "../CreateRole/CreateRole.css";

import { Row, Col } from "antd";
import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import StorageSensorApi from "../../common/Apis/StorageSensorApi";
import SensorApi from "../../common/Apis/SensorApi";
import StorageListApi from "../../common/Apis/StorageListApi";

const AddStorageSensor = () => {
  const navigate = useNavigate();
  const { Content } = Layout;
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const [loadings, setLoadings] = useState(false);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleGoBack = () => {
    navigate(-1);
  };

  const [Sensors, setSensors] = React.useState([]);
  const getSensores = useCallback(() => {
    SensorApi.ListSensors()
      .then((response) => {
        console.log(response);
        setSensors(response?.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const [Storages, setStorages] = React.useState([]);
  const getStorages = useCallback(() => {
    StorageListApi.ListStorage()
      .then((response) => {
        console.log(response);
        setStorages(response?.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    getSensores();
    getStorages();
  }, [getSensores, getStorages]);

  const handleSubmit = (data) => {
    let formData = JSON.stringify({
      value: data?.value,
      severity: data?.severity,
      sensorStatus: data?.sensorStatus,
      sensorOrigin: data?.sensorOrigin,
      correctiveAction: data?.correctiveAction,
      storageDTO: {
        id: data?.StorageID,
      },
      sensorDTO: {
        id: data?.SensorID,
      },
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
    })

    StorageSensorApi.CreateSensors(formData)
      .then((response) => {
        setLoadings(false);
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Successfully</span>,
          description: "Create Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        return navigate("/masters/storage-sensor");
      })
      .catch((err) => {
        if (err.apiError.status) {
          setLoadings(false);
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />

        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Form
            name="nest-messages"
            layout="vertical"
            className="FormClass"
            onFinish={handleSubmit}
          >
            <>
              <Row gutter={16}>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="value"
                    label="Value"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Value",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Value"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="severity"
                    label="Severity *"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please Select Severity.",
                      },
                    ]}
                  >
                    <Select
                      className="control-Select mb-1"
                      placeholder="Select Severity"
                      options={[
                        { value: "LOW", label: "LOW" },
                        { value: "MODERATE", label: "MODERATE" },
                        { value: "HIGH", label: "HIGH" },
                        { value: "CRITICAL", label: "CRITICAL" },
                        { value: "INFORMATIONAL", label: "INFORMATIONAL" },
                        { value: "WARNING", label: "WARNING" },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="sensorStatus"
                    label="Sensor Status *"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please Select Sensor Status.",
                      },
                    ]}
                  >
                    <Select
                      className="control-Select mb-1"
                      placeholder="Select Sensor Status"
                      options={[
                        { value: "ACTIVE", label: "ACTIVE" },
                        { value: "INACTIVE", label: "INACTIVE" },
                        { value: "ERROR", label: "ERROR" },
                        { value: "CALIBRATING", label: "CALIBRATING" },
                        { value: "MAINTENANCE ", label: "MAINTENANCE " },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="sensorOrigin"
                    label="Sensor Origin *"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please Select Sensor Origin.",
                      },
                    ]}
                  >
                    <Select
                      className="control-Select mb-1"
                      placeholder="Select Sensor Origin"
                      options={[
                        { value: "SYSTEM", label: "SYSTEM" },
                        { value: "MANAGER", label: "MANAGER" },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="StorageID"
                    label="Storage *"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please Select Storage.",
                      },
                    ]}
                  >
                    <Select
                      className="control-Select mb-1"
                      placeholder="Select Storage"
                    >
                      {Storages && (
                        <>
                          {Storages?.map((option, index) => (
                            <option key={index} value={option?.id}>
                              {option?.name}
                            </option>
                          ))}
                        </>
                      )}
                    </Select>
                  </Form.Item>
                </Col>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="SensorID"
                    label="Sensor *"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please Select Sensor.",
                      },
                    ]}
                  >
                    <Select
                      className="control-Select mb-1"
                      placeholder="Select Sensor"
                    >
                      {Sensors && (
                        <>
                          {Sensors?.map((option, index) => (
                            <option key={index} value={option?.id}>
                              {option?.name}
                            </option>
                          ))}
                        </>
                      )}
                    </Select>
                  </Form.Item>
                </Col>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="correctiveAction"
                    label="Corrective Action"
                    className="text-lable mt-2"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Corrective Action",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Corrective Action"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
              </Row>

              <div className="d-flex justify-content-end pt-5">
                <Link
                  type="primary"
                  to={""}
                  onClick={handleGoBack}
                  className="btn btn-primary btn-back"
                >
                  Back
                </Link>

                <Button
                  type="primary"
                  htmlType="submit"
                  className="btn btn-primary btn-save"
                >
                  Create {loadings == true && <Spin className="px-2" />}
                </Button>
              </div>
            </>
          </Form>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout >
  );
};
export default AddStorageSensor;
